import * as React from 'react';
import { useIntl } from 'react-intl';
import Linkify from 'react-linkify';
import { CategoryEntity } from '../../../../interfaces/explore/CategoryEntity';
import { MerchantDetail } from '../../../../interfaces/merchants';
import { MerchantBlogEntry } from '../../../../interfaces/merchants/blogs';
import Button, { ButtonSize } from '../../../../atoms/buttons/Button';
import Heading from '../../../../atoms/Heading';
import StringUtils from '../../../../components/utils/StringUtils';
import BaseTemplate from '../../../../organisms/merchants/BaseTemplate';
import MerchantProfile from '../../../../molecules/merchant/MerchantProfile';
import css from './MerchantBlogPostPage.module.scss';
import dynamic from 'next/dynamic';
import { buildSiteUrl } from 'src/utils/request-url';

const RichViewer = dynamic(() => import('../../../../components/RichViewer'), {
  ssr: false,
});

export interface BlogPostPageProps {
  post: MerchantBlogEntry;
  merchantDetail: MerchantDetail;
  category: CategoryEntity;
  isCoubicApp: boolean;
}

const MerchantBlogPostPage = ({
  post,
  merchantDetail,
  isCoubicApp,
}: BlogPostPageProps) => {
  const intl = useIntl();
  return (
    <BaseTemplate merchantDetail={merchantDetail} isCoubicApp={isCoubicApp}>
      <div className={css.MerchantBlogPostPage}>
        {post.primary_image ? (
          <img
            alt=""
            className={css.MerchantBlogPostPage__Image}
            src={post.primary_image?.p1280x1280.url}
          />
        ) : (
          <span className={css.MerchantBlogPostPage__Image} />
        )}
        <div className={css.MerchantBlogPostPage__Inner}>
          <h1 className={css.MerchantBlogPostPage__Title}>{post.name}</h1>
          {post.published_at !== null && (
            <p className={css.MerchantBlogPostPage__Date}>
              {intl.formatDate(new Date(post.published_at * 1000), {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </p>
          )}
          <div className={css.MerchantBlogPostPage__Body}>
            {post.is_json_description && post.description ? (
              <RichViewer value={post.description} />
            ) : (
              post.description_text && (
                <Linkify>
                  {StringUtils.simpleFormat(post.description_text)}
                </Linkify>
              )
            )}
          </div>
        </div>
        <div className={css.MerchantBlogPostPage__MerchantProfileSection}>
          <Heading className={css.MerchantBlogPostPage__Heading}>
            {intl.formatMessage(
              { id: 'merchants.details.storeData' },
              { displayName: merchantDetail.display_name },
            )}
          </Heading>
          <MerchantProfile merchantDetail={merchantDetail} />
          <div className={css.MerchantBlogPostPage__BackToTopButtonSection}>
            <Button
              className_Deprecated={css.MerchantBlogPostPage__BackToTopButton}
              isGhost={true}
              isFull={true}
              href={buildSiteUrl()}
              buttonSize={ButtonSize.Medium}
            >
              {intl.formatMessage({
                id: 'merchants.details.backToMerchantTop',
              })}
            </Button>
          </div>
        </div>
      </div>
    </BaseTemplate>
  );
};

export default MerchantBlogPostPage;
